module.exports = __webpack_public_path__ + "static/media/train-fra-azo.3fbbba87.svg";